import { IInventoryDetailUniqueItem } from './IInventoryDetailUniqueItem';

export class IMobileInventoryCountDetailDto {
  inventoryCountDetailId: string;
  inventoryCountId: string;
  recommendedInventoryLevel: number;
  adjustedRecommendedInventoryLevel: number;
  initialCount: number;
  broken: number;
  over: number;
  short: number;
  pulled: number;
  returned: number;
  ordered: number;
  tetheringNeeded: number;
  tetheringOrdered: number;
  countAdjusted: number;
  adjustedRequest: number;
  sortOrder: number;
  countNotes: string;
  itemId: string;
  partNumber: string;
  itemName: string;
  itemDescription: string;
  itemGroupId: string;
  itemInstructions: string;
  hasSerialNumber: boolean;
  manufacturerPartNumber: string;
  manufacturerId: string;
  manufacturerName: string;
  tetheringId: string;
  hasTethering: boolean;
  tetheringPartNumber: string;
  itemGroupName: string;
  itemGroupInstructions: string;
  inventoryCountDetailUniqueItems: IInventoryDetailUniqueItem[];
}
